<template>
  <v-list-tile-action v-if="!$store.getters.customerModulePlayListCommit">
    <v-menu bottom left>
      <v-btn slot="activator" icon>
        <v-icon color="grey lighten-1">more_vert</v-icon>
      </v-btn>

      <v-list>
        <v-list-tile v-if="isPlayListPage" @click="addTune">
          <v-list-tile-title>曲追加</v-list-tile-title>
        </v-list-tile>

        <v-list-tile v-if="addCommentBtn" @click="addComment">
          <v-list-tile-title>コメント編集</v-list-tile-title>
          <v-layout row justify-center>
            <v-dialog v-model="commentDialog" width="600px">
              <v-card>
                <v-card-title class="headline">コメント編集</v-card-title>
                <v-card-text>
                  <v-text-field
                    name="comment"
                    label="コメント"
                    textarea
                    v-model="comment"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" flat="flat" @click="commentDialog = false">キャンセル</v-btn>
                  <v-btn color="green darken-1" flat="flat" @click="saveComment()">保存</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-list-tile>
        <v-list-tile @click="addIsum" v-if="isShowIsumBtn">
          <v-list-tile-title>ISUM曲使用</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="addOthers" v-if="isShowOtherTuneBtn">
          <v-list-tile-title>その他の曲使用</v-list-tile-title>
        </v-list-tile>
        <div v-if="musicBtn">
          <v-list-tile v-if="addMusicBtn" @click="deleteMusic">
            <v-list-tile-title>曲削除</v-list-tile-title>
          </v-list-tile>
        </div>

        <v-list-tile v-if="addListBtn"  @click="addPlayListBtn">
          <v-list-tile-title>プレイリストに追加</v-list-tile-title>
          <v-layout row justify-center>
            <v-dialog v-model="addDialog" width="600px">
              <v-card>
                <v-card-title class="headline">プレイリストに追加</v-card-title>
                <v-card-text>
                  <p>
                    どちらのプレイリストに追加するか選択してください。<br>
                    進行プレイリストに追加する場合は、どのシーンに追加するかも選択してください。<br>
                    <span class="red--text">※すでに曲が入っている場合は上書きされます。</span><br>
                    <span class="warn-text">{{isNotExistDuplicationTune}}</span>
                  </p>
                  <v-radio-group v-model="playlist_type" column>
                    <v-radio label="進行プレイリスト" value="1"></v-radio>
                    <v-radio label="歓談プレイリスト" value="2"></v-radio>
                  </v-radio-group>

                  <v-select
                    v-if="playlist_type == '1'"
                    label="進行プレイリスト"
                    v-bind:items="progressPlaylist"
                    v-model="selectedPlayListFrame"
                    item-text="sceneName"
                    item-value="sceneName"
                    chips
                  >
                    <template slot="selection" slot-scope="data">
                      <v-chip
                        label
                        outline
                        @input="data.parent.selectItem(data.item)"
                        :selected="data.selected"
                        class="chip--select-multi"
                        :key="JSON.stringify(data.item)"
                      >
                        <v-avatar>
                          <img :src="data.item.avatar">
                        </v-avatar>
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                    <template slot="item" slot-scope="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-tile-content v-text="data.item"></v-list-tile-content>
                      </template>
                      <template v-else>
                        <v-list-tile-avatar>
                          <img v-bind:src="data.item.avatar"/>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-if="data.item.product_id == null || data.item.product_id == ''"
                            class="body-2 primary--text">曲未選択</v-list-tile-title>
                          <v-list-tile-title v-else v-html="data.item.name"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </template>
                  </v-select>

                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" flat="flat" @click="addDialog = false">キャンセル</v-btn>
                  <v-btn v-if="playlist_type == '1'" color="green darken-1" flat="flat" @click="changePlayListTune(productId, selectedPlayListFrame.customer_playlist_product_id)">追加</v-btn>
                  <v-btn v-if="playlist_type == '2'" color="green darken-1" flat="flat" @click="addChatPlaylist">追加</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-list-tile>

        <v-list-tile v-if="addFavoriteBtn" @click="addFavorite">
          <v-list-tile-title>お気に入りに追加</v-list-tile-title>
        </v-list-tile>

        <v-list-tile v-if="deleteListBtn" @click="deleteList">
          <v-list-tile-title>削除</v-list-tile-title>
        </v-list-tile>

      </v-list>
    </v-menu>
  </v-list-tile-action>
</template>

<script>
import SceneService from '@/components/services/SceneService.vue'
import FavoriteService from '@/components/services/FavoriteService.vue'
import CustomerPlayListService from '@/components/services/CustomerPlayListService.vue'

export default {
  name: 'MoreBtn',
  data () {
    return {
      isum_type: null,
      playlist_type: null,
      scene_id: null,
      selectedPlayListFrame: [],
      comment: null,
      commentDialog: false,
      isumDialog: false,
      addDialog: false,
      status: this.$store.state.snack_bar,
      isumCode: null,
      isumArtist: null,
      isumTune: null,
      otherSongName: null,
      otherSongArtistName: null,
      othersDialog: false,
      progressPlaylist: []
    }
  },
  computed: {
    otherTuneFormIsValid () {
      return (
        this.otherSongName &&
        this.otherSongArtistName
      )
    },
    isPlayListPage () {
      return this.$route.name.toString() === 'PlayList'
    },
    /**
     * productIdを指定してプレイリストに同じ楽曲が無いかを判断し、存在する場合注意文を返すメソッド
     * @param productId
     * @return {string}
     */
    isNotExistDuplicationTune () {
      if (CustomerPlayListService.isNotExistDuplicationTune(this.productId, null) === false) {
        return 'プレイリストに重複する楽曲が存在しています。'
      } else {
        return ''
      }
    },
    isShowIsumBtn () {
      return this.$store.getters.getIsumFlag && this.$route.name === 'PlayList' && this.addIsumBtn === true
    },
    isShowOtherTuneBtn () {
      return this.$store.getters.getOtherSongFlag && this.$route.name === 'PlayList'
    }
  },
  mounted () {
    // コメント情報をstoreから取得
    this.comment = this.$store.getters.getCommentText(this.playListType, this.itemIndex)
    // Isum楽曲情報をstoreから取得
    let isumObj = this.$store.getters.getIsumTuneInfo(this.playListType, this.itemIndex)
    if (isumObj) {
      this.isumCode = isumObj.isumCode ? isumObj.isumCode : null
      this.isum_type = isumObj.isumType ? isumObj.isumType : null
      this.isumTune = isumObj.isumTune ? isumObj.isumTune : null
      this.isumArtist = isumObj.isumArtist ? isumObj.isumArtist : null
    }
  },
  watch: {
    commentText () {
      this.comment = this.commentText
    },
    propIsumType () {
      this.isum_type = this.propIsumType
    },
    propIsumCode () {
      this.isumCode = this.propIsumCode
    },
    propIsumSongName () {
      this.isumTune = this.propIsumSongName
    },
    propIsumArtistName () {
      this.isumArtist = this.propIsumArtistName
    },
    otherSongName () {
      this.changeOtherTune()
    },
    otherSongArtistName () {
      this.changeOtherTune()
    }
  },
  props: [
    'addIsumBtn', 'addOthersBtn', 'addCommentBtn', 'musicBtn',
    'addMusicBtn', 'deleteMusicBtn', 'addListBtn', 'addFavoriteBtn',
    'deleteListBtn', 'productId', 'customerPlaylistProductId', 'commentText',
    'propIsumCode', 'propIsumType', 'propIsumSongName', 'propIsumArtistName', 'propSceneId',
    'propOtherName', 'propOtherArtistName', 'itemIndex', 'playListType'],
  methods: {
    addTune () {
      this.$store.dispatch('setSearchModal', [true, this.playListType, this.customerPlaylistProductId, this.itemIndex, this.propSceneId])
    },
    addIsum: function () {
      this.$store.dispatch('switchMoreBtnIsumTuneModalFlag', true)
      this.$store.dispatch('setMoreBtnModalParam', [this.playListType, this.customerPlaylistProductId, this.itemIndex])
    },
    addOthers: function () {
      this.$store.dispatch('switchMoreBtnOtherTuneModalFlag', true)
      this.$store.dispatch('setMoreBtnModalParam', [this.playListType, this.customerPlaylistProductId, this.itemIndex])
    },
    addComment: function () {
      this.commentDialog = true
    },
    /**
     * コメントを保存する
     **/
    saveComment: function () {
      let formData = new URLSearchParams()
      if (this.productId) {
        formData.append('product_id', this.productId)
      }
      formData.append('customer_playlist_product_id', this.customerPlaylistProductId)
      if (this.comment === '') {
        this.comment = null
      }
      formData.append('comment', this.comment)
      formData.append('scene_id', this.propSceneId)
      formData.append('transactionid', this.$store.state.transactionId)
      CustomerPlayListService.updatePlayListTune(formData, (response) => {
        this.$log.debug(response)
        this.addDialog = false
        this.updateParentPlayList()
      }, (error) => {
        this.$log.debug(error)
        this.errorDia = true
      })
      this.commentDialog = false
    },
    /**
     * 楽曲情報を削除するメソッド（未選択状態に戻す）
     **/
    deleteMusic: function () {
      this.$log.debug('deleteMusic START', this.customerPlaylistProductId, this.propSceneId)
      let formData = new URLSearchParams()
      formData.append('product_id', ' ')
      formData.append('customer_playlist_product_id', this.customerPlaylistProductId)
      formData.append('scene_id', this.propSceneId)
      formData.append('isum_code', ' ')
      formData.append('isum_song_name', ' ')
      formData.append('isum_artist_name', ' ')
      formData.append('isum_type', ' ')
      formData.append('other_song_name', ' ')
      formData.append('other_artist_name', ' ')
      formData.append('transactionid', this.$store.state.transactionId)
      CustomerPlayListService.updatePlayListTune(formData, (response) => {
        this.$log.debug(response)
        this.addDialog = false
        this.isumCode = null
        this.updateParentPlayList()
      }, (error) => {
        this.$log.error(error)
      })
      this.$log.debug('deleteMusic END')
    },
    /**
     * 曲をお気に入りリストに追加する機能
     **/
    addFavorite: function () {
      this.$log.debug('methods: addFavorite()')
      let formData = new URLSearchParams()
      formData.append('product_id', this.productId)
      formData.append('transactionid', this.$store.state.transactionId)
      FavoriteService.addFavoriteTune(formData, (response) => {
        this.$log.debug(response)
        this.addDialog = false
        this.status.addFavoriteDia = true
      }, (error) => {
        this.$log.debug(error)
        this.status.errorDia = true
      })
    },
    deleteList: function () {
      if (this.$route.name === 'Favorite') {
        // お気に入りリストから曲を削除
        this.removeTuneFromFavoriteList()
      } else {
        this.removeTuneFromCustomerPlayList()
      }
    },
    /**
     * お気に入りリストから曲を削除
     **/
    removeTuneFromFavoriteList: function () {
      this.$log.debug('removeTuneFromFavoriteList START', 'productId:' + this.productId)
      let formData = new URLSearchParams()
      formData.append('product_id', this.productId)
      formData.append('transactionid', this.$store.state.transactionId)
      FavoriteService.removeFavoriteTune(formData, (response) => {
        this.$log.debug(response)
        location.reload()
        this.status.deleteItemDia = true
      }, (error) => {
        this.$log.debug(error)
        this.status.errorDia = true
      })
      this.$log.debug('removeTuneFromFavoriteList END')
    },
    /**
     * 顧客プレイリストから曲を削除
     **/
    removeTuneFromCustomerPlayList: function () {
      this.$log.debug('removeTuneFromCustomerPlayList START', 'productId:' + this.productId, 'customerPlaylistProductId:' + this.customerPlaylistProductId)
      let formData = new URLSearchParams()
      formData.append('customer_playlist_product_id', this.customerPlaylistProductId)
      formData.append('transactionid', this.$store.state.transactionId)
      CustomerPlayListService.deleteTuneFromPlayList(formData, (response) => {
        this.$log.debug('removeTuneFromCustomerPlayList', response)
        this.updateParentPlayList()
        this.status.deleteItemDia = true
      }, (error) => {
        this.$log.error('removeTuneFromCustomerPlayList', error)
        this.status.errorDia = true
      })
      this.$log.debug('removeTuneFromCustomerPlayList END')
    },
    /**
     * playlistに追加するボタンを押下処理
     **/
    addPlayListBtn () {
      this.addDialog = true
      this.progressPlaylist = this.findCustomerPlayList(1)
    },
    /**
     * 新郎新婦のプレイリスト情報を取得してセレクトボックスを作成する
     **/
    findCustomerPlayList (playlistType) {
      this.$log.debug('methods: findCustomerPlayList')
      let playlist = []
      let transactionId = this.$store.state.transactionId
      CustomerPlayListService.findCustomerPlayList(playlistType, transactionId, (response) => {
        let index = 0
        for (let value in response) {
          playlist[index] = response[value]
          playlist[index].rank = index
          playlist[index].avatar = SceneService.findIconPathBySceneId(response[value].scene_id)
          if (response[value].comment === null || response[value].comment === 'null') {
            playlist[index].comment = ''
          }
          index++
        }
      }, (error) => {
        this.$log.debug(error)
        return []
      })
      return playlist
    },
    /**
     * 楽曲を変更するメソッド
     **/
    changePlayListTune: function (productId = this.productId, customerPlaylistProductId = this.selectedPlayListFrame.customer_playlist_product_id) {
      this.$log.debug('changePlayListTune')
      let formData = new URLSearchParams()
      formData.append('product_id', productId)
      formData.append('customer_playlist_product_id', customerPlaylistProductId)
      formData.append('transactionid', this.$store.state.transactionId)
      CustomerPlayListService.updatePlayListTune(formData, (response) => {
        this.$log.debug(response)
        this.addDialog = false
        this.updateParentPlayList()
        this.status.addPlayListDia = true
      }, (error) => {
        this.$log.debug(error)
        this.errorDia = true
      })
      this.commentDialog = false
    },
    /**
    * 歓談プレイリスト登録処理
    * 10曲が上限であり、未選択の枠に追加していく
    **/
    addChatPlaylist: function () {
      this.$log.debug('addChatPlaylist START')
      let playListId = 2
      if (CustomerPlayListService.countPlayListTune(playListId) >= 10) {
        alert('歓談プレイリストの楽曲数の上限は10曲です。')
        return
      }
      let customerPlaylistProductId = CustomerPlayListService.getNullPlayListBoxId(playListId)
      this.changePlayListTune(this.productId, customerPlaylistProductId)
      this.findCustomerPlayList(playListId)
      this.$log.debug('addChatPlaylist END')
    },
    /**
     * 親のコンポーネントのプレイリストを更新する
     */
    updateParentPlayList () {
      this.$emit('updateParentPlayList')
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar img {
  border-radius: 0%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/MoreBtn.vue